<template>
  <div class="vx-col w-full">
    <vx-card class="my-5" title="Filter Berdasarkan">
      <div class="w-full flex flex-col md:flex-row">
        <div class="w-full flex">
          <div class="w-full md:w-1/3 px-3 mb-1">
            <div class="mb-2">Status Presensi</div>
            <v-select :options="listStatus" v-model="filter.status" />
          </div>
          <div class="w-full md:w-1/3 px-3 mb-1">
            <div class="mb-2">Periode Bulan</div>
            <v-select :options="listMonth" v-model="filter.month" />
          </div>
          <div class="w-full md:w-1/3 px-3 mb-1">
            <div class="mb-2">Periode Tahun</div>
            <v-select :options="listYear" v-model="filter.year" />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { SELECT_OPTION_STATUS_LIST, SELECT_OPTION_YEAR_LIST, SELECT_OPTION_MONTH_LIST } from "@/const/attendance";

export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      filter: {
        status: {id: null, label: 'Semua Status'},
        month: {id: '11', label: 'November'},
        year: {id: '2022', label: 'Tahun 2022'},
      },
      listStatus : SELECT_OPTION_STATUS_LIST,
      listMonth : SELECT_OPTION_MONTH_LIST,
      listYear : SELECT_OPTION_YEAR_LIST
    };
  },
  watch: {
    filter: {
      handler(){
        this.$emit('reloadData', this.filter);
      },
      deep: true
    }
  },
  methods: {
    reloadData() {
      this.$emit('reloadData', this.filter);
    }
  }
};
</script>